import { cn } from "../../lib/utils";

type SortHeaderProps<K extends string> = {
  label: string;
  sortKey: K;
  currentSort: K;
  currentDir: "asc" | "desc";
  onSort: (key: K) => void;
  className?: string;
};

export function SortHeader<K extends string>({
  label,
  sortKey,
  currentSort,
  currentDir,
  onSort,
  className,
}: SortHeaderProps<K>) {
  const isActive = currentSort === sortKey;
  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      className={cn(
        "text-xs font-display font-bold uppercase tracking-widest transition-colors",
        isActive ? "text-brand-400" : "text-surface-400 hover:text-surface-300",
        className,
      )}
    >
      {label}
      {isActive && (currentDir === "desc" ? " \u2193" : " \u2191")}
    </button>
  );
}
